import {
    FETCH_PREFERENCES_SUCCESS,
    FETCH_PREFERENCES_LOADING
} from "./index" 

import {apiCall} from "../../functions/utils"

export const fetchPreferencesSuccess = (data) => {
    return {
        type : FETCH_PREFERENCES_SUCCESS,
        payload: data.data
    }
}

export const fetchPreferencesLoading = () => {
    return {
        type : FETCH_PREFERENCES_LOADING
    }
}

export const fetchPreferencesError = (e) => {
    console.log("Error in fetchPreferencesError", e);
    return {
        type : FETCH_PREFERENCES_SUCCESS,
        payload: {
            send_to_voicemail: 1,
            show_notes: 1,
            show_delete: 1,
            forward_calls: 0,
            forward_calls_phones: "",
            is_signature: 0,
            signature_text: "",
        }
    }
}

export const fetchPreferences = () => {
    return async (dispatch) => {
        dispatch(fetchPreferencesLoading())
        try{
            const res = await apiCall(true, "GET", `/api/preferences`)
            dispatch(fetchPreferencesSuccess(res.data))
        }catch(e){
            dispatch(fetchPreferencesError(e))
        } 
    }
}

export const updatePreferences = (data) => {
    return async (dispatch) => {
        try{
            const res = await apiCall(true, "POST", `/api/preferences`, data)
            dispatch(fetchPreferencesSuccess(res.data))
        }catch(e){
            dispatch(fetchPreferencesError(e))
        } 
    }
}